import styles from './Home.module.css';

const Home = () => {
    return <div className={styles.home}>Home Page</div>;
};

export default Home;
